import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import Pricing from './components/Pricing/Pricing';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Console branding
    console.log('%c🚀 NV Consulting - Your Business Partner', 'color: #0066cc; font-size: 18px; font-weight: bold;');
    console.log('%cMaking compliance easy and affordable', 'color: #666; font-size: 12px;');
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
